import { render, staticRenderFns } from "./com-finance-list.vue?vue&type=template&id=3fa211c4&scoped=true&"
import script from "./com-finance-list.vue?vue&type=script&lang=js&"
export * from "./com-finance-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa211c4",
  null
  
)

export default component.exports